<template>
    <div>
        <div class="topbox wow animated fadeInDown" data-wow-duration="1.5s">

            <div class="box">
                <div class="left" @click="goto('index',0)">
                    <img src="../assets/image/logo.png" alt/>
                </div>
                <div class="right">
                    <ul>
                        <li class="animated fadeIn" @click="goto('index',0)">
                            <a :class="{showA:num==0}">首页</a>
                        </li>
                        <li class="animated fadeIn" @click="goto('about',1)">
                            <a :class="{showA:num==1}">关于我们</a>
                            <div class="mList">
                                <div class="allList">
                                    <p @click.stop="gotoAbout(0)">企业介绍</p>
                                    <p @click.stop="gotoAbout(1)">企业文化</p>
                                    <p @click.stop="gotoAbout(2)">恒昌年志</p>
                                    <p @click.stop="gotoAbout(4)">企业荣誉</p>
                                </div>
                            </div>
                        </li>
                        <li class="animated fadeIn" @click="goto('news',2)">
                            <a :class="{showA:num==2}">新闻资讯</a>
                            <div class="mList">
                                <div class="allList">
                                    <p @click.stop="gotoNews(0)">公司新闻</p>
                                    <p @click.stop="gotoNews(1)">媒体报道</p>
                                    <p @click.stop="gotoNews(2)">视频展播</p>
                                </div>
                            </div>
                        </li>
                        <li class="animated fadeIn" @click="goto('businessintro',3)">
                            <a :class="{showA:num==3}">业务介绍</a>
                            <div class="mList">
                                <div class="allList">
                                    <p @click.stop="gotoBusinessIntro(0)">住宅物业</p>
                                    <p @click.stop="gotoBusinessIntro(1)">办公物业</p>
                                    <p @click.stop="gotoBusinessIntro(2)">公共物业</p>
                                    <p @click.stop="gotoBusinessIntro(3)">职工餐服务</p>
                                </div>
                            </div>
                        </li>
                        <!-- <li class="animated fadeIn" @click="goto('market',4)">
                            <a :class="{showA:num==4}">市场合作</a>
                        </li> -->
                        <li class="animated fadeIn" @click="goto('join',5)">
                            <a :class="{showA:num==5}">加入我们</a>
                        </li>
                        <li class="animated fadeIn" @click="goto('smart',6)">
                            <a :class="{showA:num==6}">智慧物业</a>
                        </li>
                        <li class="animated fadeIn" @click="goto('contact',7)">
                            <a :class="{showA:num==7}">联系我们</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="phonemenu wow animated fadeInDown" data-wow-duration="1.5s">
                <div class="mNav" @click="menuSwitch" :class="{active:menuShow}">
                    <span class="burger"></span>
                    <span class="burger"></span>
                    <span class="burger"></span>
                </div>
                <div class="right">
                    <img src="../assets/image/logo.png" alt/>
                </div>
            </div>

        </div>
        <div class="hidemenu" :class="{menushow:menuShow}">
            <ul>
                <li><a href="./index.html">首页</a></li>
                <li><a href="./about.html">关于我们</a></li>
                <li><a href="./news.html">新闻资讯</a></li>
                <li><a href="./businessintro.html">业务介绍</a></li>
                <li><a href="./market.html">市场合作</a></li>
                <li><a href="./join.html">加入我们</a></li>
                <li><a href="./smart.html">智慧物业</a></li>
                <li><a href="./contact.html">联系我们</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {WOW} from "wowjs";

    export default {
        data() {
            return {
                num: 0,
                menuShow: false
            };
        },
        mounted() {
            var wow = new WOW({});
            wow.init();
            if (localStorage.getItem('index')) {
                this.num = localStorage.getItem('index')
            }
            console.log(this.num)
        },
        methods: {
            goto(name, num) {
                localStorage.setItem('index', num)
                const url = `./${name}.html`;
                window.open(url, "_self");
            },
            gotoAbout(id) {
                localStorage.setItem('index', 1)
                const url = `./about.html?id=${id}`;
                window.open(url, "_self");
            },
            gotoNews(id) {
                localStorage.setItem('index', 2)
                const url = `./news.html?id=${id}`;
                window.open(url, "_self");
            },
            gotoBusinessIntro(id) {
                localStorage.setItem('index', 3)
                const url = `./businessintro.html?id=${id}`;
                window.open(url, "_self");
            },
            menuSwitch() {
                this.menuShow = !this.menuShow
            }
        }
    };
</script>

<style lang="less" scope>
    .topbox {
        position: fixed;
        top: 0;
        width: 100%;
        margin: 0px auto;
        display: flex;
        justify-content: center;
        height: auto;
        align-items: center;
        z-index: 10;
        background-color: white;

        .box {
            width: 80%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .left {
                float: left;
                width: 231px;
                height: 80px;
                margin: 10px 0;

                img {
                    cursor: pointer;
                    width: 100%;
                    height: 80%;
                }
            }

            .right {
                width: 80%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                height: 100px;

                ul {
                    float: right;
                    width: 100%;
                    height: 100px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    list-style: none;
                    align-items: center;
                    margin-left: 5%;

                    li {
                        position: relative;
                        margin-left: 2%;
                        cursor: pointer;
                        height: 100px;
                        list-style: none;

                        &::marker {
                            height: 0;
                        }

                        a {
                            font-family: "SourceHanSansSC";
                            list-style: none;
                            margin: 0;
                            border: 0;
                            outline: none;
                            cursor: pointer;
                            text-decoration: none;
                            position: relative;
                            display: block;
                            padding: 10px 10px 0 10px;
                            height: 100px;
                            line-height: 80px;
                            color: black;
                            transition: all 300ms;

                            &:hover {
                                color: #f39900;
                            }
                        }

                        .showA {
                            color: #f39900;
                        }

                        .mList {
                            position: absolute;
                            left: -50px;
                            bottom: -200px;
                            width: auto;
                            flex-direction: row;
                            justify-content: center;
                            /*display: none;*/
                            background-color: #f29700;
                            z-index: -100;
                            animation: showmList 400ms forwards linear;
                            display: none;

                            .allList {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: space-between;

                                p {
                                    padding: 20px 50px;
                                    white-space: nowrap;
                                    font-size: 16px;
                                    font-family: Source Han Sans SC;
                                    font-weight: 400;
                                    transition: all 300ms;

                                    &:hover {
                                        color: white;
                                    }
                                }
                            }

                            @keyframes showmList {
                                from {
                                    opacity: 0;
                                    transform: translateY(80px);
                                }
                                to {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        }

                        &:hover {
                            .mList {
                                display: block;
                                bottom: -61px;
                            }
                        }
                    }
                }
            }
        }

        .phonemenu {
            display: none;
        }
    }
    .hidemenu{
        display: none;
    }

    @media screen and (max-width: 450px) {
        .topbox {
            .box {
                display: none;
            }

            .phonemenu {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 80px;

                .mNav {
                    display: block;
                    transition: .8s;
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 60px;
                }

                .mNav .burger {
                    width: 32px;
                    height: 3px;
                    background-color: #f29700;
                    position: absolute;
                    top: 25px;
                    left: 50%;
                    margin: 0px 0px 0px -16px;
                    transform-origin: center;
                    transition: .8s;
                }

                .mNav .burger:nth-of-type(2) {
                    top: 35px;
                }

                .mNav .burger:nth-of-type(3) {
                    top: 45px;
                }

                .mNav.active {
                    /*background-color:#2bad38;*/
                }

                .mNav.active .burger {
                    background-color: #286AA0;
                }

                .mNav.active .burger:nth-of-type(1) {
                    top: 35px;
                    transform: rotate(225deg);
                }

                .mNav.active .burger:nth-of-type(2) {
                    left: -100%;
                    opacity: 0;
                }

                .mNav.active .burger:nth-of-type(3) {
                    top: 35px;
                    transform: rotate(-225deg);
                }

                .right {
                    width: 40%;
                    height: 80px;
                    margin-left: 20%;

                    img {
                        width: 100%;
                        height: 60px;
                        margin-top: 10px;
                    }
                }
            }

        }

        .hidemenu{
            display: none;
        }


        .menushow {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            width: 50%;
            background-color: #f29700;
            height: 100%;
            z-index: 1;
            transform: translateZ(0);
            ul{
                margin-top: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                li{
                    list-style: none;
                    width: 100%;
                    text-align: center;
                    padding: 10px 0;
                    a{
                        color: white;
                    }
                }
            }
        }
    }
</style>
